module.exports = __webpack_public_path__ + "static/media/american-football-signals.d53e2f7a.svg";